const MODELO_DOCUMENTO = Object.freeze({
	ATIVO: { text: 'Ativo', value: 'ATIVO' },
	INATIVO: { text: 'Inativo', value: 'INATIVO' },
})

const TIPO_DOCUMENTO = Object.freeze({
	ATIVO: { text: 'Ativo', value: 'ATIVO' },
	INATIVO: { text: 'Inativo', value: 'INATIVO' },
})

const DOCUMENTO = Object.freeze({
	CRIADO: { text: 'Criado', value: 'CRIADO' },
	JUNTADO: { text: 'Juntado', value: 'JUNTADO' },
	CANCELADO: { text: 'Cancelado', value: 'CANCELADO' },
	RASCUNHO: { text: 'Rascunho', value: 'RASCUNHO' },
	DESATUALIZADO: { text: 'Desatualizado', value: 'DESATUALIZADO' },
	JUNTADO_DESATUALIZADO: { text: 'Juntado Desatualizado', value: 'JUNTADO_DESATUALIZADO' },
})

const PEDIDO = Object.freeze({
	RASCUNHO: { text: 'Rascunho', value: 'RASCUNHO' },
	EM_ELABORACAO: { text: 'Em Elaboração', value: 'EM_ELABORACAO' },
	CONCLUIDO: { text: 'Concluído', value: 'CONCLUIDO' },
	EFETIVADO: { text: 'Efetivado', value: 'EFETIVADO' },
})

const ATA = Object.freeze({
	EM_ELABORACAO: { text: 'Em Elaboração', value: 'EM_ELABORACAO' },
	EFETIVADO: { text: 'Efetivada', value: 'EFETIVADO' },
	HISTORICO_PRORROGACAO: { text: 'Ata Prorrogada', value: 'HISTORICO_PRORROGACAO' },
	CANCELADO: { text: 'Cancelada', value: 'CANCELADO' },
	GESTAO_PEDIDO: {
		EM_ANDAMENTO: [PEDIDO.EM_ELABORACAO.value, PEDIDO.RASCUNHO.value, PEDIDO.EFETIVADO.value],
		CONCLUIDO: [PEDIDO.CONCLUIDO.value],
	},
})

const ADESAO = Object.freeze({
	RASCUNHO: { text: 'Em rascunho', value: 'RASCUNHO' },
	EM_ELABORACAO: { text: 'Em Elaboração', value: 'EM_ELABORACAO' },
	ENVIADO_ANALISE: { text: 'Aguardando Análise', value: 'ENVIADO_ANALISE' },
	AGUARDANDO_ANALISE: { text: 'Aguardando Análise', value: 'AGUARDANDO_ANALISE' },
	ENVIADO_ADERENTE: { text: 'Enviado', value: 'ENVIADO_ADERENTE' },
	EM_ANALISE: { text: 'Em Análise', value: 'EM_ANALISE' },
	CONCLUIDO: { text: 'Concluído', value: 'CONCLUIDO' },
	RECUSADO: { text: 'Recusado', value: 'RECUSADO' },
	ACEITO: { text: 'Aceito', value: 'ACEITO' },
	ACEITA: { text: 'Aceita', value: 'ACEITA' },
	AGUARDANDO_ANUENCIA: { text: 'Aguardando', value: 'AGUARDANDO_ANUENCIA' },
	ASSINADO: { text: 'Assinado', value: 'ASSINADO' },
	AGUARDANDO_ASSINATURA: { text: 'Aguardando Assinatura', value: 'AGUARDANDO_ASSINATURA' },
})

const DOCUMENTO_PNCP = Object.freeze({
	ENVIADO: { text: 'Enviado', value: 'ENVIADO' },
	ERRO: { text: 'Erro', value: 'ERRO' },
})

const ADITIVO_APOSTILA = Object.freeze({
	EFETIVADO: { text: 'Efetivado', value: 'EFETIVADO' },
	RASCUNHO: { text: 'Em Rascunho', value: 'RASCUNHO' },
	AGUARDANDO_EFETIVACAO: { text: 'Aguardando Efetivação', value: 'AGUARDANDO_EFETIVACAO' },
})

const FISCAIS = Object.freeze({
	ATIVO: { text: 'Ativo', value: 'ATIVO' },
	INATIVO: { text: 'Inativo', value: 'INATIVO' },
})

export default {
	ATA,
	MODELO_DOCUMENTO,
	TIPO_DOCUMENTO,
	DOCUMENTO,
	PEDIDO,
	ADESAO,
	DOCUMENTO_PNCP,
	ADITIVO_APOSTILA,
	FISCAIS,
}
